import { Button } from "@/components/ui/button";
import { ArrowDown, Calendar } from "lucide-react";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import BookingSection from "@/components/BookingSection";

const HeroSection = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Animated gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-gradient-start via-gradient-mid to-gradient-end animate-gradient-shift bg-[length:400%_400%]" />
      
      {/* Overlay pattern */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, currentColor 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }} />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center">
        <div className="animate-fade-in-up">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-4">
            Ilan Klimberg
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-6 font-medium">
            Product Manager | Blockchain & AI
          </p>
          <p className="text-lg text-white/80 max-w-2xl mx-auto mb-12 leading-relaxed">
            Product-focused builder with experience at Coinbase, leading blockchain education at Cornell, 
            and founding companies. Passionate about creating innovative solutions at the intersection 
            of Web3 and AI.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Dialog>
              <DialogTrigger asChild>
                <Button
                  size="lg"
                  className="bg-white text-[hsl(var(--primary-contrast))] hover:bg-white/90 font-semibold px-8 py-6 text-lg group"
                >
                  <Calendar className="mr-2 h-5 w-5" />
                  Book a Call
                </Button>
              </DialogTrigger>
              <DialogContent className="max-w-6xl w-[95vw] h-[90vh] p-0 bg-transparent border-0 [&>button]:z-[100] [&>button]:text-white [&>button]:hover:text-white/80 [&>button]:bg-white/10 [&>button]:hover:bg-white/20 [&>button]:backdrop-blur-sm [&>button]:rounded-full [&>button]:w-10 [&>button]:h-10 [&>button]:flex [&>button]:items-center [&>button]:justify-center">
                <BookingSection />
              </DialogContent>
            </Dialog>

            <Button
              size="lg"
              className="bg-white/10 text-white border-2 border-white/30 hover:bg-white hover:text-primary font-semibold px-8 py-6 text-lg backdrop-blur-sm"
              onClick={() => scrollToSection("chat")}
            >
              Ask Me Anything
              <ArrowDown className="ml-2 h-5 w-5 animate-gentle-bounce" />
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll indicator - subtle animation */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-gentle-bounce">
        <ArrowDown className="h-6 w-6 text-white/60" />
      </div>
    </section>
  );
};

export default HeroSection;
